import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Subject } from 'rxjs';
import {
  NewPeriodEmitWrapper,
  PeriodToCopyDto,
} from 'src/app/domain/fund-performance/component/shared/modal-copy-period/dto/PeriodToCopyDto';
import { FundPerformanceBackendService } from 'src/app/domain/fund-performance/service/fund-performance-backend.service';
import { NotificationsService } from '../../../../../core/service/notifications.service';
import {
  NewPeriodInputWrapper,
  ModalCopyPeriodFormService,
  NEW_PERIOD_IS_EQUAL_TO_INITIAL_PERIOD,
  NEW_PERIOD_IS_NOT_PROVIDED,
} from "./modal-copy-period.util";
import { takeUntil } from "rxjs/operators";
import { YYYY_MM_DD } from "../../../../../util/common/date-service/date.service";

@Component({
  selector: 'app-modal-copy-period',
  templateUrl: './modal-copy-period.component.html',
  styleUrls: ['./modal-copy-period.component.scss'],
})

export class ModalCopyPeriodComponent implements OnInit, OnDestroy {
  private _destroyStream: Subject<void> = new Subject<void>();

  protected readonly YYYY_MM_DD = YYYY_MM_DD;
  @Input({ transform: reverseOrder }) periods: string[] | Date[];
  @Input() selectedFundUuid: string;
  @Input() selectedPeriod: Date;
  @Output() emitter = new EventEmitter<NewPeriodEmitWrapper>();

  modalCopyPeriodFormService: ModalCopyPeriodFormService;
  isUpdatingExpenses = true;

  newPeriod: NewPeriodInputWrapper = {
    additionalClass: '',
    bottomText: '',
  };

  constructor(
    private fpService: FundPerformanceBackendService,
    private notificationService: NotificationsService,
  ) { }

  ngOnInit(): void {
    this.modalCopyPeriodFormService = new ModalCopyPeriodFormService(this.selectedPeriod.toString());
    this.modalCopyPeriodFormService.form.statusChanges
      .pipe(takeUntil(this._destroyStream))
      .subscribe(() => {
        this.updateNewPeriodWrapper(false);
      });
  }

  ngOnDestroy(): void {
    this._destroyStream.next();
    this._destroyStream.complete();
  }

  close(updatePeriodsInNavBar: boolean): void {
    if (updatePeriodsInNavBar) {
      this.emitter.emit({
        newPeriod: this.modalCopyPeriodFormService.form.value.newPeriod,
        showUpdateFpModal: this.isUpdatingExpenses,
      });
    } else {
      this.emitter.emit(null);
    }
    this.ngOnDestroy();
  }

  confirmCopyingRoundByFundIdAndPeriod(): void {
    this.updateNewPeriodWrapper(true);
    if (!this.modalCopyPeriodFormService.form.valid) {
      return;
    }
    const periodToCopy: PeriodToCopyDto = {
      initialPeriod: this.modalCopyPeriodFormService.form.value.initialPeriod,
      newPeriod: this.modalCopyPeriodFormService.form.value.newPeriod,
    };
    this.fpService.copy(this.selectedFundUuid, periodToCopy).subscribe({
      next: () => {
        this.notificationService.success(
          { title: 'Added period', message: 'Successfully added period: ' + periodToCopy.newPeriod.toString() });
        this.close(true);
      },
    });
  }

  updateExpensesChecked(): void {
    this.isUpdatingExpenses = !this.isUpdatingExpenses;
  }

  private updateNewPeriodWrapper(isContinueClicked: boolean): void {
    const form = this.modalCopyPeriodFormService.form;
    if (isContinueClicked && form.hasError(NEW_PERIOD_IS_NOT_PROVIDED)) {
      this.newPeriod.additionalClass = 'error';
      this.newPeriod.bottomText = 'Set new period date';
    } else if (!isContinueClicked && form.hasError(NEW_PERIOD_IS_EQUAL_TO_INITIAL_PERIOD)) {
      this.newPeriod.additionalClass = 'error';
      this.newPeriod.bottomText = 'New period date must be unique';
    } else {
      this.newPeriod.additionalClass = '';
      this.newPeriod.bottomText = '';
    }
  }
}

function reverseOrder(periods: string[] | Date[]): (string | Date)[] {
  return periods.slice().reverse(); // slice instead of deepCopy (saves extra import)
}
